import React, { useState, useEffect, useCallback } from "react";
import InvoiceListHeader from "./InvoiceListHeader";
import InvoiceSearchBox from "./InvoiceSearchBox";
import InvoiceSalesReportFilter from "./InvoiceSalesReportFilter";
import InvoiceDataGrid from "./InvoiceDataGrid";
import InvoiceActivityLogs from "./InvoiceActivityLogs";
import InvoicePrintPreview from "./InvoicePrintPreview";
import useDocumentList from "../../hooks/useDocumentList";
import canUserSeeThis from "../common/CheckCanUserSeeThis";

const InvoiceList = () => {
  const {
    config,
    searchTerm,
    setSearchTerm,
    searchType,
    setSearchType,
    showSidebar,
    setShowSidebar,
    pageSize,
    setPageSize,
    columnVisibilityModel,
    setColumnVisibilityModel,
    documentData,
    columns,
    rows,
    selectionModel,
    setSelectionModel,
    selectedRowData,
    setSelectedRowData,
    loading,
    handleEdit,
    handleView,
    pageNumber,
    setPageNumber,
    currentEnd,
    currentStart,
    totalCount,
    refreshDocumentList
  } = useDocumentList({
    docType: "INV",
    docLabel: "Invoice",
    p2Value: "ORDER_DATE",
    docNoField: "INVNO",
    editRoute: "/sales_invoice",
    screenCode: "INVCOUNT",
  });

  const [reportSealImage, setReportSealImage] = useState(null);
  const [reportWatermarkImage, setReportWatermarkImage] = useState(null);

  const fetchSealData = useCallback(async () => {
    if (!config?.BASE_URL || !config?.COMPANY_CODE || !config?.DEPARTMENT_NO) return;
    try {
      const url = `${config.BASE_URL}/api/CpaysCount/${config.COMPANY_CODE}/DEPTLH/${config.DEPARTMENT_NO}/-`;
      const response = await fetch(url);
      if (response.ok) {
        const data = await response.json();
        // if (data && data.length > 0 && data[0].SEAL != null && data[0].watermark != null) {
        if (data && data.length > 0) {
          setReportSealImage(data[0].SEAL);
          setReportWatermarkImage(data[0].watermark);
        }
      }
    } catch (err) {
      console.warn("Error fetching seal data:", err);
    }
  }, [config?.BASE_URL, config?.COMPANY_CODE, config?.DEPARTMENT_NO]);

  useEffect(() => {
    fetchSealData();
  }, [fetchSealData]);
  return (
    <div className="min-h-screen bg-gray-50">
      <InvoiceListHeader
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        invoiceId={selectedRowData[config.docNoField]}
        BASE_URL={config.BASE_URL}
        COMPANY_CODE={config.COMPANY_CODE}
        DEPARTMENT={config.DEPARTMENT_NO}
        title={"Invoice List"}
      />

      <div className="max-w-full mx-auto py-2 space-y-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <InvoiceSearchBox
            searchTerm={searchTerm}
            searchType={searchType}
            setSearchTerm={setSearchTerm}
            setSearchType={setSearchType}
            filteredInvoices={documentData}
            totalCount={totalCount}
          />
          <InvoiceSalesReportFilter
            invoiceData={documentData}
            DEPARTMENT={config.DEPARTMENT_NO}
            COMPANY_CODE={config.COMPANY_CODE}
            BASE_URL={config.BASE_URL}
            REPORT_HEADER_IMAGE={config.REPORT_HEADER_IMAGE}
            REPORT_FOOTER_IMAGE={config.REPORT_FOOTER_IMAGE}
          />
          <InvoicePrintPreview
            invoiceNo={selectedRowData?.[config.docNoField]}
            DEPARTMENT={config.DEPARTMENT_NO}
            COMPANY_CODE={config.COMPANY_CODE}
            BASE_URL={config.BASE_URL}
            REPORT_FOOTER_IMAGE={config.REPORT_FOOTER_IMAGE}
            REPORT_HEADER_IMAGE={config.REPORT_HEADER_IMAGE}
            COMPANY_NAME={config.COMPANY_NAME}
            VAT_PERCENTAGE={config.VATPERCENTAGE}
            ZATCASTATUS={config.ZATCASTATUS}
            reportSealImage={reportSealImage}
            reportWatermarkImage={reportWatermarkImage}
          />
        </div>

        <div className="grid grid-cols-12 gap-4">
          {showSidebar && (
            <InvoiceActivityLogs
              invoiceId={selectedRowData[config.docNoField]}
              COMPANY_CODE={config.COMPANY_CODE}
              BASE_URL={config.BASE_URL}
              modificationType={"INVOICETIMELINE"}
              printType={"INVPRINTTIMELINE"}
              DEPARTMENT={config.DEPARTMENT_NO}
            />
          )}
          <div
            className={`col-span-12 ${showSidebar ? "lg:col-span-9" : "lg:col-span-12"
              } transition-all duration-300`}
          >
            <InvoiceDataGrid
              setColumnVisibilityModel={setColumnVisibilityModel}
              setPageSize={setPageSize}
              columnVisibilityModel={columnVisibilityModel}
              pageSize={pageSize}
              rows={rows}
              columns={columns}
              loading={loading}
              selectionModel={selectionModel}
              setSelectionModel={setSelectionModel}
              setSelectedRowData={setSelectedRowData}
              activeRowId={selectedRowData?.id}
              selectedRowData={selectedRowData}
              onEdit={handleEdit}
              reviewMode="INVOICE"
              onView={handleView}
              pageNumber={pageNumber}
              showApproveReject={config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN" ||
                canUserSeeThis("ZT")}
              setPageNumber={setPageNumber}
              currentEnd={currentEnd}
              totalCount={totalCount}
              currentStart={currentStart}
              showSidebar={showSidebar}
              docLabel={"INV"}
              enableF5Action={false}
              showEdit={config.CURRENT_USER_ROLE?.toUpperCase() === "ADMIN" ||
                canUserSeeThis("YV")}
              config={config}
              refreshDocumentList={refreshDocumentList}

            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceList;
